export const PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE = 'widget.planning-schedule-chart'
